var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(1===2)?_c('div',{staticClass:"d-flex align-center pb-3"},[_c('div',{staticClass:"display-1"},[_vm._v("\n      "+_vm._s(_vm.user.name)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('profile-toolbar'),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }